import React from "react";
import { useDraggable } from "@dnd-kit/core";

interface DraggableItemProps {
  id: string;
  name: string;
}

const DraggableAnalytics: React.FC<DraggableItemProps> = ({ id, name }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const style: React.CSSProperties = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      className="cursor-grab text-ellipsis"
      data-testid={`draggableListItem${name}`}
    >
      <div {...listeners} className="flex h-full justify-center px-1">
        {name}
      </div>
    </div>
  );
};

export default DraggableAnalytics;
